export default __webpack_public_path__ + "static/media/sc45.903039e3.jpg";